import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from './base-service.service';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService extends BaseService {

  constructor(private http: HttpClient) { super(); }

  GetClassificationStatistics(): Observable<any> {
    return this.http.get(this.getUrl(`Analytics/ClassificationStatistics/`));
  }

  GetBranchOfficeChart(): Observable<any> {
    return this.http.get(this.getUrl(`Analytics/BranchOfficeStatistics/`));
  }

  GetAdvisorChart(): Observable<any> {
    return this.http.get(this.getUrl(`Analytics/AdvisorStatistics/`));
  }
}
